import {
  apiAddScanWalletAddress,
  apiDeleteBillingWalletAddress,
  apiGetBillingWalletAddress,
} from "@lib/api/wallet";
import { UseQueriesProps } from "@lib/types/General";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

export const useWalletAddressQueries = (props: UseQueriesProps) => {
  const { queryKey, params, id, messages, enabled = true } = props;
  const queryKeys = queryKey || [
    "wallet-address",
    params ? JSON.stringify(params) : id,
  ];
  const queryClient = useQueryClient();

  const walletAddressQuery = useQuery({
    queryFn: () => apiGetBillingWalletAddress(params),
    queryKey: queryKeys,
    enabled: !!params && !!enabled,
  });

  const addScanWalletAddressMutation = useMutation({
    mutationFn: apiAddScanWalletAddress,
    mutationKey: queryKeys,
    onSuccess() {
      queryClient.resetQueries({
        predicate: (query) => {
          const key = query.queryKey;
          return JSON.stringify(key).includes("wallet-address");
        },
      });
    },
  });

  const deleteWalletAddressMutation = useMutation({
    mutationFn: apiDeleteBillingWalletAddress,
    onSuccess() {
      toast.success(
        (messages["common.deletedMessage"] as string).replace(
          "{name}",
          messages["common.walletAddress"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });

      queryClient.resetQueries({
        predicate: (query) => {
          const key = query.queryKey;
          return JSON.stringify(key).includes("wallet-address");
        },
      });
    },
  });

  return {
    walletAddressQuery,
    deleteWalletAddressMutation,
    addScanWalletAddressMutation,
  };
};
